<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Customer from '@/components/widgets/customer'
import CustomerService from '@/services/customer'

export default {
  page: {
    title: "Clientes - CRM",
  },
  components: { Layout, PageHeader, Customer },
  data() {
    return {
      title: "Clientes - CRM",
      loading: false,
      customers: [],
      
      searchValue: '',
      searchUf: '',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      showModal: false,
      searchEmptyField: false,
    }
  },
  computed: {
    rows() {
      return this.customers.length;
    }
  },
  methods: {
    loadCustomers(showLoading = true, page = 1) {
      if (showLoading) {
        this.loading = true;
      }

      CustomerService.getAll(page, this.searchValue, this.searchUf, true)
        .then(res => {
          this.loading = false;

          this.customers = res.data.customers;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadCustomers(true, this.currentPage);
    },
    search() {
      this.searchEmptyField = false,
      this.loadCustomers(true, 1);
    },
    changeSearch() {
      if (this.searchValue === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadCustomers(true, 1);
      }
    }
  },
  mounted() {
    this.loadCustomers();
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row mb-3">
                <div class="col">
                  <label>Razão Social, Fantasia, código ou CNPJ</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchValue"
                    v-on:keyup="changeSearch"
                  />
                </div>

                <div class="col col-2">
                  <label>UF</label>
                  <select class="custom-select" v-model="searchUf">
                    <option value="">Todos</option>
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AP">AP</option>
                    <option value="AM">AM</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MT">MT</option>
                    <option value="MS">MS</option>
                    <option value="MG">MG</option>
                    <option value="PA">PA</option>
                    <option value="PB">PB</option>
                    <option value="PR">PR</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RS">RS</option>
                    <option value="RO">RO</option>
                    <option value="RR">RR</option>
                    <option value="SC">SC</option>
                    <option value="SP">SP</option>
                    <option value="SE">SE</option>
                    <option value="TO">TO</option>
                  </select>
                </div>

                <div class="col button-bottom">
                  <button type="submit" class="btn btn-primary" v-if="!loading">
                    Pesquisar
                  </button>

                  <a href="javascript:void(0);" class="text-primary" v-if="loading">
                    <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                  </a>
                </div>
              </div>
            </form>

            <div v-if="customers && customers.length > 0">
              <!-- Table data -->
              <Customer :customers="customers" :loadCustomers="this.loadCustomers" :action="$route.query.action"/>

              <div class="row justify-content-md-between align-items-md-center mt-4">
                <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
                <!-- end col-->
                <div class="col-xl-5">
                  <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                    <b-pagination
                      v-model="currentPage" 
                      :total-rows="count"
                      :per-page="perPage"
                      @input="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
                <!-- end col-->
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- <div class="row" v-if="loading">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-primary">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </a>
        </div>
      </div>
    </div> -->
  </Layout>
</template>

<style lang="scss">
  .search-input form {
    display: flex;
    flex-direction: row;

    .btn {
      margin-left: 10px;
    }
  }

  .button-bottom {
    display: flex;
    align-items: flex-end;
  }
</style>